import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useLocation } from 'react-router-dom';
import { ImageComponent } from '../../global/imageComponent';
import { useDispatch } from 'react-redux';
import { getGamedatas } from '../../actions/gameSettings';
import SportIcon from '../../common/SportIcon';

export default function AllSportsSlider({ data = [] }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentSport = decodeURIComponent(location.pathname.split("/")[2] || "");

  const [sliderData, setSliderData] = useState(data); // start with prop data

  // Fetch dynamic game data and merge with prop data
  const fetchGameData = async () => {
    try {
      const { status, result } = await getGamedatas(dispatch);
      if (status === true && Array.isArray(result)) {
        const dynamicData = result.map((sport, index) => ({
          subId: index + 1,
          labelText: sport._id || sport.name || `Sport ${index + 1}`,
          navLink: "/straight-bet",
          iconUrl: sport.iconUrl || null,
          count: sport.count || 0,
        }));

        // Merge prop data + dynamic data (avoid duplicates by labelText)
        const mergedData = [
          ...sliderData.filter(item => !dynamicData.find(d => d.labelText === item.labelText)),
          ...dynamicData
        ];

        setSliderData(mergedData);
      }
    } catch (err) {
      console.error("Error fetching sports data:", err);
    }
  };

  useEffect(() => {
    fetchGameData();
  }, []);

  return (
    <div className='allSportsSliderWrapper'>
      <button className='sliderCustomBtn sliderLeftBtn'>
        <span><IoIosArrowBack /></span>
      </button>

      <Swiper
        modules={[Navigation]}
        spaceBetween={10}
        slidesPerView={"auto"}
        className='allSportsSwiper'
        navigation={{
          prevEl: '.sliderLeftBtn',
          nextEl: '.sliderRightBtn'
        }}
      >
        {sliderData.map((item, index) => {
          const isLiveMobius =
            item.labelText === "Live" || item.labelText === "livemobius";
          const isActive =
            currentSport === item.labelText ||
            (isLiveMobius && currentSport === "livemobius");

          // 🧭 Determine correct route based on label
          let linkPath = `/straight-bet/${encodeURIComponent(item.labelText)}`;
          let linkState = { selectedSport: item.labelText };

          if (item.labelText === "Favorites") {
            linkPath = "/favorites";
          } else if (item.labelText === "Call Bets") {
            linkPath = `/callbet`;
          } else if (item.labelText === "Active Bets") {
            linkPath = `/openbet`;
          } else if (isLiveMobius) {
            linkPath = "/straight-bet/livemobius";
            linkState = { selectedSport: "livemobius" };
          }

          return (
            <SwiperSlide className='allSportsSwiperSlide' key={index}>
              <Link
                to={linkPath}
                state={linkState}
                className={`allSportsSliderContent ${isActive ? "active" : ""}`}
              >
                <div className='imgWrapper'>
                  {item.iconSrc ? (
                    <ImageComponent staticImgSrc={item.iconSrc} />
                  ) : (
                    <SportIcon
                      sportName={item.labelText}
                      iconUrl={item.iconUrl}
                      size={28}
                    />
                  )}
                  {item.count > 0 && <span className="liveBage2">{item.count}</span>}
                </div>
                <h3 className='fs13'>{item.labelText}</h3>
              </Link>
            </SwiperSlide>
          );
        })}

      </Swiper>

      <button className='sliderCustomBtn sliderRightBtn'>
        <span><IoIosArrowForward /></span>
      </button>
    </div>
  );
}
